import { createVNode as a, mergeProps as n } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/FileTxtTwotoneStandard.js";
import d from "../components/PfIcon.js";
const t = (o, r) => {
  const e = {
    ...o,
    ...r.attrs
  };
  return a(d, n(e, {
    icon: i
  }), null);
};
t.displayName = "FileTxtTwotoneStandard";
t.inheritAttrs = !1;
export {
  t as default
};
